import _ from 'lodash';
import { isFirefox, isIE } from './detect-browser';
export { isIE, isFirefox };
export const getMouseEventOffset = function (event) {
    let order = ['offset', 'layer'];
    if (isFirefox()) {
        order = ['layer', 'offset'];
    }
    for (let i = 0; i < order.length; i++) {
        const prop = order[i];
        const propX = `${prop}X`;
        const propY = `${prop}Y`;
        if (propX in event) {
            return {
                x: event[propX],
                y: event[propY],
            };
        }
    }
    const target = event.target || event.srcElement;
    const rect = target.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;
    return {
        x: offsetX,
        y: offsetY,
    };
};
export function padWithLeadingZeros(number, desiredWidth) {
    const numberAsStr = number.toString();
    const currentWidth = numberAsStr.length;
    if (numberAsStr.includes('.')) {
        desiredWidth++;
    }
    if (currentWidth >= desiredWidth) {
        return numberAsStr;
    }
    return '0'.repeat(desiredWidth - currentWidth) + numberAsStr;
}
export function mapArrayToHash(array, mappingFunction, defaultValue) {
    const hash = {};
    const defaultValueIsFunction = _.isFunction(defaultValue);
    array.forEach(function (element, index) {
        const key = mappingFunction(element, index);
        let value = element;
        if (defaultValue) {
            if (defaultValueIsFunction) {
                value = defaultValue(element, index);
            }
            else {
                value = defaultValue;
            }
        }
        hash[key] = value;
    });
    return hash;
}
export function mapArrayToBooleanHash(array, valueToKeyFunction) {
    if (!array) {
        return null;
    }
    if (!valueToKeyFunction) {
        valueToKeyFunction = _.identity;
    }
    const hash = {};
    array.forEach(function (item) {
        const key = valueToKeyFunction(item);
        hash[key] = true;
    });
    return hash;
}
export function computeAxisInfinityPlaceholderValue(min, max) {
    if (min === Number.NEGATIVE_INFINITY || min === Number.POSITIVE_INFINITY) {
        return 1;
    }
    if (min === max) {
        return (max + 1) * 10;
    }
    return Math.max(Math.abs(max), Math.abs(min)) + Math.abs(max - min);
}
//# sourceMappingURL=index.js.map